import { TransactionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/transaction/paginated/transaction.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { TransactionListLocationCell } from './transaction-list-location.cell';
import { TransactionListLocationHeader } from './transaction-list-location.header';

export const TransactionListLocationColumn: IdentifiedColumnDef<
  TransactionModel,
  TransactionModel['location']
> = {
  enableSorting: false,
  header: TransactionListLocationHeader,
  cell: TransactionListLocationCell,
  meta: { maxWidth: '110px', width: '80px', minWidth: '60px' },
};
